//export class RequisitionItemWorkflowListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionItemWorkflowListPageComponent, isMenuHidden: true }];
//};

import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/RequisitionItemWorkflowDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class RequisitionItemWorkflowEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemWorkflow"}, method: "GET" };
	//get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemWorkflow/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemWorkflow/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemWorkflow/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemWorkflow/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemWorkflow/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemWorkflow/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class RequisitionItemWorkflowFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public requisitionItemId: IFieldOptions = { field: "requisitionItemId" };
	public workflowId: IFieldOptions = { field: "workflowId" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public userId: IFieldOptions = { field: "userId" };
	public comments: IFieldOptions = { field: "comments" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.requisitionItemId);
		this.push(this.workflowId);
		this.push(this.datestamp);
		this.push(this.userId);
		this.push(this.comments);
	}
}

export class RequisitionItemWorkflowForm implements IFormOptions {
	protected requisitionItemWorkflowFormName: string = "requisitionItemWorkflowForm";
	protected requisitionItemWorkflowFormModel: models.RequisitionItemWorkflowDTO = new models.RequisitionItemWorkflowDTO();
	protected requisitionItemWorkflowFormEndPoints: RequisitionItemWorkflowEndPoints = new RequisitionItemWorkflowEndPoints();
	protected requisitionItemWorkflowFormFields: RequisitionItemWorkflowFormFields = new RequisitionItemWorkflowFormFields();
	public get name(): string { return this.requisitionItemWorkflowFormName };
	public get model(): models.RequisitionItemWorkflowDTO { return this.requisitionItemWorkflowFormModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionItemWorkflowFormEndPoints };
       public set endPoints(requisitionItemWorkflowEndPoints: IEntityEndPoints) {
		this.requisitionItemWorkflowFormEndPoints = requisitionItemWorkflowEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): RequisitionItemWorkflowFormFields { return this.requisitionItemWorkflowFormFields };
}

export class RequisitionItemWorkflowListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public requisitionItemId: IColumnOptions = { field: "requisitionItemId" };
	public workflowId: IColumnOptions = { field: "workflowId" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public userId: IColumnOptions = { field: "userId" };
	public comments: IColumnOptions = { field: "comments" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.requisitionItemId);
		this.push(this.workflowId);
		this.push(this.datestamp);
		this.push(this.userId);
		this.push(this.comments);
	}
}

export class RequisitionItemWorkflowList implements IGridOptions {
	protected requisitionItemWorkflowListName: string = "requisitionItemWorkflowList";
	protected requisitionItemWorkflowListModel: models.RequisitionItemWorkflowDTO = new models.RequisitionItemWorkflowDTO();
	protected requisitionItemWorkflowListEndPoints: RequisitionItemWorkflowEndPoints = new RequisitionItemWorkflowEndPoints();
	protected requisitionItemWorkflowListColumns: RequisitionItemWorkflowListColumns = new RequisitionItemWorkflowListColumns();
	public requisitionItemWorkflowForm: RequisitionItemWorkflowForm = new RequisitionItemWorkflowForm();
	public get name(): string { return this.requisitionItemWorkflowListName };
	public get model(): models.RequisitionItemWorkflowDTO { return this.requisitionItemWorkflowListModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionItemWorkflowListEndPoints };
	public set endPoints(requisitionItemWorkflowEndPoints: IEntityEndPoints) {
		this.requisitionItemWorkflowListEndPoints = requisitionItemWorkflowEndPoints;
		this.requisitionItemWorkflowForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): RequisitionItemWorkflowListColumns { return this.requisitionItemWorkflowListColumns };
}

export class RequisitionItemWorkflowEntity implements IEntityOptions {
	protected requisitionItemWorkflowEntityName: string = "requisitionItemWorkflowEntity";
	protected requisitionItemWorkflowEntityModel: models.RequisitionItemWorkflowDTO = new models.RequisitionItemWorkflowDTO();
	protected requisitionItemWorkflowEntityEndPoints: RequisitionItemWorkflowEndPoints = new RequisitionItemWorkflowEndPoints();
	protected requisitionItemWorkflowEntityList: RequisitionItemWorkflowList = new RequisitionItemWorkflowList();
	public get name(): string { return this.requisitionItemWorkflowEntityName };
	public get model(): models.RequisitionItemWorkflowDTO { return this.requisitionItemWorkflowEntityModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionItemWorkflowEntityEndPoints };
	public set endPoints(requisitionItemWorkflowEndPoints: IEntityEndPoints) {
		this.requisitionItemWorkflowEntityEndPoints = requisitionItemWorkflowEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): RequisitionItemWorkflowList { return this.requisitionItemWorkflowEntityList };
	public get form(): RequisitionItemWorkflowForm { return this.grid.requisitionItemWorkflowForm };
	constructor(name?: string) {
		if (name) this.requisitionItemWorkflowEntityName = name;
		this.endPoints = this.requisitionItemWorkflowEntityEndPoints;
	}
};
//export class RequisitionItemWorkflowGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: RequisitionItemWorkflowForm = new RequisitionItemWorkflowForm();
//};

//export class RequisitionItemWorkflowListPageComponent extends ListPageComponent {
  //protected listPageComponentList: RequisitionItemWorkflowList = new  RequisitionItemWorkflowList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class RequisitionItemWorkflowBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionItemWorkflowGeneratedForm}];
//};

